import { TableCell } from '@mui/material';
import displayDateTime from '../functions/displayDateTime'; 

// pass row object as prop
const RebateTrailRow = ({ row, count, tableHeader,stickyEnabled }) =>{

    const getRowClassName = (columnOrder) =>{
        // Pass sticky row class if columnOrder is 0 i.e first column and stickyEnabled Prop is true
        return stickyEnabled && columnOrder===0 ? "table-cell-sticky-row": ""
    }    
    return(
        <>
            {/* map display over all columns of row component */}
            {tableHeader.map(el => 
                el['columnname'] == 'actiontimestamp' ? 
                    <TableCell className={getRowClassName(el['columnorder'])}>{displayDateTime(row[el['columnname']])}</TableCell>
                : <> 
                    {row[el['columnname']] == null ?
                    <TableCell className={getRowClassName(el['columnorder'])}>None</TableCell>
                    :<TableCell className={getRowClassName(el['columnorder'])}>{row[el['columnname']]}</TableCell>}
                </>
            )}
        </>
    );
}

export default RebateTrailRow; 